import React, { useMemo } from "react";
import { PANEL_TYPES } from "../../panel-types";
import Standard from "./types/Standard";
import CustomIcon from "./types/CustomIcon";
import Dot from "./types/Dot";

const Panels = {
  [PANEL_TYPES.STANDARD]: Standard,
  [PANEL_TYPES.CUSTOM_ICON]: CustomIcon,
  [PANEL_TYPES.CUSTOM_EMOJI]: CustomIcon,
  [PANEL_TYPES.DOT]: Dot,
};

function Panel({ data, isEditable = false, isTemplate = false, viewMode }) {
  const { type } = data;

  const PanelComponent = useMemo(() => Panels[type] || Standard, [type]);

  return (
    <PanelComponent
      data={data}
      isEditable={isEditable}
      isTemplate={isTemplate}
      viewMode={viewMode}
    />
  );
}

export default Panel;
